import * as React from 'react';
import { SxProps, Typography } from '@mui/material';
import { memo } from 'react';

import { useRecordContext } from 'react-admin';
import AvatarField from './AvatarField';

const FullNameField = (props: any) => {
    const { size } = props;
    const record = useRecordContext<any>();
    return record ? (
        <Typography
            variant="body2"
            display="flex"
            flexWrap="nowrap"
            alignItems="center"
            component="div"
            sx={props.sx}
        >
            <AvatarField
                record={record}
                size={size}
                sx={{
                    mr: 1,
                    mt: -0.5,
                    mb: -0.5,
                }}
            />
            <div>
                <div>
                    {`${record?.firstName ?? record?.first_name ?? ''} ${
                        record?.lastName ?? record?.last_name ?? ''
                    }`}
                </div>

                <div>{record.phone}</div>
                <div>{record?.email}</div>
            </div>
        </Typography>
    ) : null;
};

FullNameField.defaultProps = {
    source: 'lastName',
    label: 'resources.customers.fields.name',
};

export default memo(FullNameField);
